var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6B511A",
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,431.589c-22.207,0-40.21,17.994-40.21,40.202c0,22.207,18.003,40.21,40.21,40.21 s40.21-18.003,40.21-40.21C296.21,449.583,278.207,431.589,256,431.589z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.758,323.522h-33.564v88.605c5.367-1.507,10.989-2.343,16.782-2.343c5.786,0,11.406,0.836,16.782,2.343 V323.522z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.581,455.008v33.564h106.731c-1.507-5.367-2.351-10.989-2.351-16.782c0-5.793,0.844-11.415,2.351-16.782 H89.581z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.064,471.79c0,5.793-0.836,11.415-2.344,16.782h106.731v-33.564H315.721 C317.228,460.375,318.064,465.997,318.064,471.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.732,62.933c-15.544,0-30.36,3.09-43.955,8.554C325.48,29.238,282.411,0,232.4,0 c-67.161,0-121.883,52.649-125.513,118.908c-3.982-0.533-8.014-0.91-12.152-0.91c-49.961,0-90.466,40.497-90.466,90.466 c0,49.968,40.505,90.465,90.466,90.465h294.996c65.17,0,117.999-52.829,117.999-117.998 C507.731,115.762,454.901,62.933,389.732,62.933z M283.976,180.899v61.531h-55.943v-61.531h-33.564L256,105.38l61.54,75.519 H283.976z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProfile);
export default __webpack_public_path__ + "static/media/upload-profile.cfcfe6b20f3e2772ee5ae75a4f361f07.svg";
export { ForwardRef as ReactComponent };